/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_4_QInputs */

const en_landing_faq_4_q = /** @type {(inputs: Landing_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much does Alchema cost?`)
};

const de_landing_faq_4_q = /** @type {(inputs: Landing_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viel kostet Alchema?`)
};

const fr_landing_faq_4_q = /** @type {(inputs: Landing_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien coute Alchema ?`)
};

const es_landing_faq_4_q = /** @type {(inputs: Landing_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuanto cuesta Alchema?`)
};

const it_landing_faq_4_q = /** @type {(inputs: Landing_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto costa Alchema?`)
};

const nl_landing_faq_4_q = /** @type {(inputs: Landing_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel kost Alchema?`)
};

const pl_landing_faq_4_q = /** @type {(inputs: Landing_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ile kosztuje Alchema?`)
};

const fi_landing_faq_4_q = /** @type {(inputs: Landing_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paljonko Alchema maksaa?`)
};

const da_landing_faq_4_q = /** @type {(inputs: Landing_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvor meget koster Alchema?`)
};

const sv_landing_faq_4_q = /** @type {(inputs: Landing_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hur mycket kostar Alchema?`)
};

/**
* | output |
* | --- |
* | "How much does Alchema cost?" |
*
* @param {Landing_Faq_4_QInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_faq_4_q = /** @type {((inputs?: Landing_Faq_4_QInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_4_QInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_faq_4_q(inputs)
	if (locale === "fr") return fr_landing_faq_4_q(inputs)
	if (locale === "es") return es_landing_faq_4_q(inputs)
	if (locale === "it") return it_landing_faq_4_q(inputs)
	if (locale === "nl") return nl_landing_faq_4_q(inputs)
	if (locale === "pl") return pl_landing_faq_4_q(inputs)
	if (locale === "fi") return fi_landing_faq_4_q(inputs)
	if (locale === "da") return da_landing_faq_4_q(inputs)
	if (locale === "sv") return sv_landing_faq_4_q(inputs)
	return en_landing_faq_4_q(inputs)
});